<template>

  <default-view>
    <span slot="header">Not found</span>

    <template slot="content">
      <h1>Page Not Found</h1>

      <p>Requested page not found in application.</p>

      <p>
        Take me
        <router-link to="/">home</router-link>
        .
      </p>
    </template>

  </default-view>

</template>

<script>
	import DefaultView from "./DefaultView"

	export default {
		name: "NotFoundView",
		components: {DefaultView}
	}
</script>

<style scoped>

</style>